// overflow-y values whose elements can actually scroll. `hidden` is included on purpose — it hides
// the scrollbar but still scrolls programmatically and via the browser's native focus-scroll. `visible`
// and `clip` are excluded (they never scroll).
const SCROLLABLE_OVERFLOW = ['auto', 'scroll', 'hidden', 'overlay'];

/**
 * Collects every scrollable ancestor of `node`, nearest-first.
 *
 * Used to pin scroll positions when a child (e.g. the TinyMCE editor iframe) takes pointer focus:
 * the browser scrolls *every* nested scroll container to reveal the iframe, so all of them must be
 * captured, not just the nearest one.
 */
export const getScrollableAncestors = (node: HTMLElement | null): HTMLElement[] => {
  const ancestors: HTMLElement[] = [];
  let el = node?.parentElement ?? null;
  while (el) {
    const { overflowY } = getComputedStyle(el);
    if (SCROLLABLE_OVERFLOW.includes(overflowY) && el.scrollHeight > el.clientHeight + 1) {
      ancestors.push(el);
    }
    el = el.parentElement;
  }
  return ancestors;
};
